import { type FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useUserOptions } from '@/api/generated';
import Combobox, { type ComboboxProps } from '@/components/ui/combobox';
import { Skeleton } from '@/components/ui/skeleton';

type UserComboboxProps = Omit<ComboboxProps<false>, 'options'>;

const UserCombobox: FC<UserComboboxProps> = ({ ...props }) => {
  const { t } = useTranslation();

  const { data: users, isLoading } = useUserOptions();
  const options = useMemo(
    () =>
      (users ?? []).map((user) => ({
        label: user.email,
        value: user.id,
      })),
    [users]
  );

  if (isLoading) {
    return <Skeleton className='h-10 w-full' />;
  }

  return (
    <Combobox
      {...props}
      placeholder={t('components.userCombobox.placeholder')}
      options={options}
    />
  );
};

export default UserCombobox;
